const awsConfigStaging = {
  aws_project_region: 'eu-west-2',
  aws_appsync_graphqlEndpoint:
    'https://n3tmshvujfbjfgwfnodkp5amsu.appsync-api.eu-west-2.amazonaws.com/graphql',
  aws_appsync_region: 'eu-west-2',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_cognito_identity_pool_id:
    'eu-west-2:9df373b4-b6ad-49fa-b72f-5c1eac503930',
  aws_cognito_region: 'eu-west-2',
  aws_user_pools_id: 'eu-west-2_vfbNOukJY',
  aws_user_pools_web_client_id: '1133eb84mhjd4f7vnuke6j9f5v',
  oauth: {
    domain: 'popp-stage.auth.eu-west-2.amazoncognito.com',
    scope: [
      'phone',
      'email',
      'openid',
      'profile',
      'aws.cognito.signin.user.admin'
    ],
    redirectSignIn: 'http://localhost:3000/,https://staging.ai.joinpopp.com/',
    redirectSignOut: 'http://localhost:3000/,https://staging.ai.joinpopp.com/',
    responseType: 'code'
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: ['GOOGLE'],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: []
  },
  aws_cognito_verification_mechanisms: ['EMAIL']
};

// eslint-disable-next-line no-undef
module.exports = awsConfigStaging;
